import DesktopBrowserBar from "./desktop-browser-bar.jpg";

export const DesktopMocksImages = { BrowserBar: DesktopBrowserBar };
